import { render, staticRenderFns } from "./intransit.vue?vue&type=template&id=12cdc67f&scoped=true&"
import script from "./intransit.vue?vue&type=script&lang=js&"
export * from "./intransit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12cdc67f",
  null
  
)

export default component.exports